import Axios from "axios";
// Actions
import {
    GET_CASES,
    mergeManagerContact,
    saveAllDocuments,
    saveAllMessages,
    saveCareManager,
    saveCases,
    saveContacts,
    setLoadingCases
} from "../actions/cases";
import {clearListDocuments, GET_DOCUMENTS, saveDocuments} from "../actions/chatCase/document";
import {setRedirection} from "../actions/user";
import {setErrorApiMessage} from "../actions/apiFlag";
// Utils
import {getSession} from "../common/session.service";
import {getApiBaseUrl} from "../utils/baseUrl";

// On définit par défaut un TimeOut à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const cases = (store) => (next) => (action) => {
    switch (action.type) {
        case GET_CASES : {
            // @TODO : Ce middleware peut être optimisé. Il y a beaucoup d'appel API, surtout s'il y a plusieurs cas existant.
            // Peut-être qu'il est possible d'améliorer la requête SQL côté backend pour optimiser le résultat envoyé

            const url = `${getApiBaseUrl()}/getCases/`;
            // Récupération des valeurs de la session
            const sessionObj = getSession();
            const {session} = sessionObj;

            const payload = {
                session
            };

            Axios.post(url, payload, {withCredentials: true})
                .then((res) => {
                    // Ne pas hésiter à console.log(res) pour voir le contenu de la réponse
                    const state = store.getState();

                    // S'il exite des cas
                    if (res.data.listCases !== null && state.cases.listCases.length === 0) {
                        // Récupération de la liste des cas
                        store.dispatch(saveCases(res.data.listCases));

                        // Récupération de la liste des manager associé au cas
                        const url2 = `${getApiBaseUrl()}/getCareManager/`;
                        const url3 = `${getApiBaseUrl()}/getContacts/`;
                        const url4 = `${getApiBaseUrl()}/getDocuments/`;
                        const url5 = `${getApiBaseUrl()}/getMessages/`;

                        // On map la liste des cas
                        res.data.listCases.map((cas) => {
                            // S'il existe un id Case Manager dans chaque cas
                            if (cas.idManager !== null) {
                                // On le récupère
                                const payload = {
                                    "id": cas.idCareManager
                                };
                                //====== Requête pour les caremanager
                                Axios.post(url2, payload).then((res) => {
                                    // S'il n'y a toujours pas de listCareManager
                                    if (state.cases.listCareManager.length === 0) {
                                        // On sauvegarde ceux provenant de la requête
                                        store.dispatch(saveCareManager(res.data.dataCareManager));
                                        store.dispatch(setLoadingCases(false));
                                    }
                                });

                                // ====== Requête pour les contacts
                                const Payload = {
                                    "session": {
                                        "id": window.localStorage.id,
                                        "idUser": window.localStorage.idUser,
                                        "email": window.localStorage.email,
                                    },
                                    "idCase": cas.id
                                };

                                // ========= Requête pour les contacts
                                Axios.post(url3, Payload)
                                    .then((res) => {
                                        if (res.data.listContacts !== null && state.cases.listContacts.length === 0) {
                                            // On sauvegarde les contacts en lien avec chaque cas du user
                                            store.dispatch(saveContacts(res.data.listContacts));
                                        }
                                    })
                                    .then(() => store.dispatch(mergeManagerContact())); // On dispatch une action du reducers (./reducer/cases.js) qui associe les cas, les contacts et les caremanager

                                // Requête pour récupérer la liste des documents de chaque cas
                                Axios.post(url4, Payload).then((res) => {
                                    if (res.data.listDocuments !== null && state.cases.listDocuments.length === 0) {
                                        store.dispatch(saveAllDocuments(res.data.listDocuments));
                                    }
                                });
                                // Requête pour récupérer tous les message de chaque cas
                                Axios.post(url5, Payload).then((res) => {
                                    if (res.data.listMessages !== null && state.chatCase.messages.length === 0) {
                                        store.dispatch(saveAllMessages(res.data.listMessages));
                                    }
                                });
                            }
                        });
                    }
                })
                .catch((err) => {
                    if (err) {
                        // Si l'api ne répond pas au bout de 10 seconde, on signale une erreur à l'utilisateur
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
            next(action);
            break;
        }
        case GET_DOCUMENTS : {

            const url4 = `${getApiBaseUrl()}/getDocuments/`;
            // Destructuring du state global
            const state = store.getState();
            const {chatCase} = state;

            // récupération des id de session
            const sessionObj = getSession();
            const {session} = sessionObj;

            const payload = {
                session,
                "idCase": chatCase.idCase
            };

            Axios.post(url4, payload).then((res) => {
                        if (res.data.listDocuments === null) {
                            store.dispatch(clearListDocuments());
                            store.dispatch(saveDocuments([]));
                        } else {
                            // Sauvegarde des documents s'il en existe
                            store.dispatch(saveDocuments(res.data.listDocuments));
                        }
                    }
                )
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err) {
                        // Si l'api ne répond pas au bout de 10 seconde, on signale une erreur à l'utilisateur
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });

            next(action);
            break;
        }
        default:
            next(action);
    }
};

export default cases;